<template>
    <v-dialog v-model="dialog" width="500px">
      <v-card>
        <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
        <v-card-text>Are you sure you want to remove this price update from the accommodation {{hspa.huis_code}} ?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="warning mx-2" small @click="rmHspa">Yes</v-btn>
          <v-btn color="success"  small @click="dialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </template>
    
    <script>
    
    export default {
      data() { 
        return {
          dialog: false,
          hspa_encrid: null,
          hspa: {}
        }
      },
      methods: {
        open(hspa_encrid) {
          this.$emit("showSnackbar");
          this.dialog = true;
          this.$axios
            .post("ares/json/ares/huis/hspa/getHspa.p", {
              header: {
                token: this.$session.get("ARES"),
                clientSessionId: this.$session.id(),
                request: "getHspa"
              },
              getHspa: {
                hspa_encrid: hspa_encrid
              }
            })
            .then(res => {
              if (res.data.error) {
                console.log(res.data.error);
              } else {
                this.hspa = res.data.getHspa;
              }
            })
            .finally(() => {
              this.loading = false;
            });
        },
        rmHspa() { 
          this.$axios
            .post("ares/json/ares/huis/hspa/rmHspa.p", {
              header: {
                token: this.$session.get("ARES"),
                clientSessionId: this.$session.id(),
                request: "rmHspa"
              },
              rmHspa: {
                hspa_encrid: this.hspa.hspa_encrid
              }
            })
            .then(res => {
              if (res.data.error) {
                console.log(res.data.error);
              }  else { 
                 this.$store.dispatch('setSnackbar', {
                  showing: true,
                  text: res.data.rmHspa.text,
                  color: res.data.rmHspa.color
                });
                this.$emit("updateData")
                this.dialog = false;
              }
            })
        },
      }
    }
    </script>
    
    